import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface AiGeneratedBadgeProps {
  label?: string;
  'data-testid'?: string;
}

/**
 * Small pill flagging content that was produced by the AI investigator, so a
 * reviewer can tell an AI-generated plan/note apart from human-authored ones.
 * Rendered next to the surfaced "[Investigation Plan]" document.
 */
export const AiGeneratedBadge: React.FC<AiGeneratedBadgeProps> = ({
  label = 'AI-generated',
  'data-testid': dataTestId = 'ai-generated-badge',
}) => (
  <Box
    component="span"
    data-testid={dataTestId}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1,
      py: 0.25,
      borderRadius: '999px',
      border: 1,
      borderColor: 'primary.main',
      color: 'primary.main',
      lineHeight: 1,
    }}
  >
    <AutoAwesomeIcon sx={{ fontSize: '14px' }} />
    <Typography
      variant="caption"
      fontWeight={600}
      sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}
    >
      {label}
    </Typography>
  </Box>
);
